<template>
  <v-container>
    <v-layout>
      <v-flex class="text-xs-center">
        <h1>available soon</h1>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: 'functionsDoc'
}
</script>

<style scoped>

</style>
